"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var baseImage_1 = require("./baseImage");
var variant = {
    VARIANT: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    fragment Variant on Variant {\n      code\n      attributes {\n        name\n        year\n        modelName\n        fullSpecsUrl\n      }\n    }\n  "], ["\n    ", "\n    fragment Variant on Variant {\n      code\n      attributes {\n        name\n        year\n        modelName\n        fullSpecsUrl\n      }\n    }\n  "])), baseImage_1.default.BASE_IMAGE),
};
exports.default = variant;
var templateObject_1;
